<template>
  <q-splitter :value="value" unit="px" :limits="[value, value]">
    <template v-slot:before>
      <slot name="before" />
    </template>
    <template v-slot:after>
      <slot name="after" />
    </template>
  </q-splitter>
</template>

<script>
export default {
  name: 'Splitter',
  props: {
    value: {
      type: Number,
    },
  },
};
</script>

<style lang="scss" scoped></style>
